import clsx from 'clsx';

import { TabPanel } from 'shared/ui/tabs';
import { BoostEmRecommendationOption } from 'shared/api/insights';

import { patchHTMLWithLinks } from '../../utils';
import styles from '../styles.module.scss';

type TeachingTipProps = {
  index: number;
  activeTabIndex: number;
  recommendationOption: BoostEmRecommendationOption;
};

export const TeachingTip = ({
  index,
  activeTabIndex,
  recommendationOption,
}: TeachingTipProps) => {
  return (
    <TabPanel index={index} activeTabIndex={activeTabIndex}>
      <h4 className={styles.optionTitle}>Teaching Tip of the Week</h4>
      <ul className={styles.optionTagList}>
        {recommendationOption.tags.map((tag, index) => (
          <li
            key={tag}
            className={clsx(styles.optionTag, {
              [styles.bolded]: index === 0,
            })}
            dangerouslySetInnerHTML={{ __html: tag }}
          />
        ))}
      </ul>
      <div
        className={styles.optionContent}
        dangerouslySetInnerHTML={{
          __html: patchHTMLWithLinks(recommendationOption.recommendation),
        }}
      />
    </TabPanel>
  );
};
